import DragDrawer from './drag-drawer.vue'
export default DragDrawer



// WEBPACK FOOTER //
// ./src/components/drag-drawer/index.js